import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  IGlobalPropertiesState,
  selectConfiguration,
  selectPropertyList,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import SuccessStoryEditPage from '../components/SuccessStoryEditPage'
import {
  actionCreators,
  ISuccessStoriesEditState,
  selectCanEdit,
  selectError,
  selectIsLoading,
  selectIsSaving,
  selectLoadingPhotos,
  selectPropertyPhotos,
  selectSuccessStory,
} from '../modules/successStoriesEdit'

type IComponentState = ISuccessStoriesEditState &
  IGlobalConfigurationState &
  IGlobalPropertiesState

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      canEdit: selectCanEdit(),
      configuration: selectConfiguration(),
      error: selectError(),
      properties: selectPropertyList(),
      isLoading: selectIsLoading(),
      isSaving: selectIsSaving(),
      loadingPhotos: selectLoadingPhotos(),
      propertyPhotos: selectPropertyPhotos(),
      successStory: selectSuccessStory(),
    }),
    actionCreators,
  )(SuccessStoryEditPage),
)
